export const CREW_ROLES = [
  {
    name: "writers",
    label: "Please list the Writer(s) of this film.",
    shortLabel: "Writer(s)",
  },
  {
    name: "editors",
    label: "Please list the Editor(s) of this film.",
    shortLabel: "Editor(s)",
  },
  {
    name: "dps",
    label: "Please list the Cinematographer(s) of this film.",
    shortLabel: "Cinematographer(s)",
  },
  {
    name: "producers",
    label: "Please list the Producer(s) of this film.",
    shortLabel: "Producer(s)",
    tooltipInfo:
      "This is someone that helped on the film in any way that doesn't fall under the other categories.",
  },
  {
    name: "actors",
    label: "Please list the Actor(s) in this film.",
    shortLabel: "Actor(s)",
  },
  {
    name: "executiveProducers",
    label: "Please list the Executive Producer(s) of this film.",
    shortLabel: "Executive Producer(s)",
    tooltipInfo: (
      <span>
        This is someone other than the director that lent <i>any</i> gear or a
        location to the production.
      </span>
    ),
  },
];
